/**
 * Bankame Widget — Integración con Shopify
 * Tienda: SWISS   ·   Tema: The4 / "t4s"
 * v1.1.0-debug — v1.0.0 + instrumentación para diagnosticar por qué los datos
 * del cliente no llegan a la orden de Shopify (ni al contado ni en cuotas).
 *
 * Lo que agrega esta versión (el flujo funcional no cambia):
 *   1. stringify SEGURO para los logs. En v1.0.0, si el payload del widget
 *      tenía referencias circulares o nodos del DOM, JSON.stringify tiraba
 *      excepción, el catch la comía y el log del payload NUNCA llegaba ni a
 *      localStorage ni al backend ni al panel. Solo quedaba en la consola.
 *   2. Mapa plano de TODO el payload (ruta → valor) en cada callback.
 *   3. Resolución campo por campo del cliente, indicando de dónde salió cada
 *      valor y avisando cuáles quedaron vacíos (por eso se guarda
 *      "Cliente Bankame").
 *   4. Sniffer de postMessage del iframe del widget (por si los datos del
 *      cliente viajan por ahí y el SDK no los reenvía a onClientConfirmed).
 *   5. Callbacks "espía": se registran nombres de callbacks alternativos para
 *      descubrir qué otros eventos emite el SDK.
 *   6. Log del body EXACTO que se manda a create-pending-order y de la
 *      respuesta completa del backend.
 *
 * Debug:
 *   ?bankame_logs=1  → panel flotante de logs
 *   ?bankame_logs=2  → panel + loguea TODOS los postMessage (muy ruidoso)
 *   mostrarBankameLogs()  → abre el panel
 *   bankameDumpLogs()     → devuelve el array de logs
 *   window.bankameDebug   → config, saleData, último payload, cliente detectado
 */

(function () {
  "use strict";

  if (window.__bankameIntegrationLoaded) return;
  window.__bankameIntegrationLoaded = true;

  var config     = window.bankameConfig || {};
  var apiKey     = config.apiKey     || "";
  var widgetUrl  = config.widgetUrl  || "";
  var backendUrl = config.backendUrl || "";
  var storeId    = config.storeId    || "";
  var mode       = config.mode || (config.isCart === "yes" ? "cart" : "product");

  // Nivel de verbosidad por querystring
  var VERBOSE_POSTMESSAGE = false;
  try {
    var qs = new URL(window.location.href).searchParams.get("bankame_logs");
    VERBOSE_POSTMESSAGE = qs === "2";
  } catch (_) {}

  // Poné en false si el SDK se queja de claves desconocidas en init()
  var ESPIAR_CALLBACKS = true;

  // ═══════════════════════════════════════════════════════════════════
  // Serialización segura (circulares, DOM, funciones, BigInt…)
  // ═══════════════════════════════════════════════════════════════════
  function stringifySeguro(valor) {
    var vistos = [];
    try {
      return JSON.stringify(valor, function (clave, val) {
        if (typeof val === "function") return "(function)";
        if (typeof val === "bigint")   return String(val);
        if (typeof Element !== "undefined" && val instanceof Element) return "(DOM " + val.tagName + ")";
        if (typeof Window  !== "undefined" && val instanceof Window)  return "(Window)";
        if (val && typeof val === "object") {
          if (vistos.indexOf(val) !== -1) return "(circular)";
          vistos.push(val);
        }
        return val;
      });
    } catch (e) {
      return '"(no serializable: ' + (e && e.message) + ')"';
    }
  }

  function clonarParaLog(valor) {
    if (valor === null || valor === undefined) return null;
    try {
      return JSON.parse(stringifySeguro(valor));
    } catch (e) {
      return { _error_serializacion: String(e && e.message), _tipo: typeof valor };
    }
  }

  // ═══════════════════════════════════════════════════════════════════
  // Logger centralizado (consola + localStorage + backend)
  // ═══════════════════════════════════════════════════════════════════
  var BANKAME_LOG_KEY       = "bankame_frontend_logs_" + storeId;
  var BANKAME_LOG_MAX_LOCAL = 400;

  function bankameLog(level, message, context) {
    var nivel = (level || "INFO").toUpperCase();
    var entry = {
      timestamp: new Date().toISOString(),
      store_id:  storeId,
      source:    "widget-" + mode,
      level:     nivel,
      message:   String(message || ""),
      context:   clonarParaLog(context),
      page_url:  window.location.href
    };

    try {
      var tag = "[Bankame:" + entry.level + "]";
      // Se loguea el objeto ORIGINAL en consola (inspeccionable) y el clon
      // seguro va a storage/backend.
      if (nivel === "ERROR")                        console.error(tag, entry.message, context !== undefined ? context : "");
      else if (nivel === "WARN" || nivel === "WARNING") console.warn(tag, entry.message, context !== undefined ? context : "");
      else                                          console.log(tag, entry.message, context !== undefined ? context : "");
    } catch (_) {}

    try {
      var stored = JSON.parse(localStorage.getItem(BANKAME_LOG_KEY) || "[]");
      stored.push(entry);
      while (stored.length > BANKAME_LOG_MAX_LOCAL) stored.shift();
      localStorage.setItem(BANKAME_LOG_KEY, JSON.stringify(stored));
    } catch (e) {
      try { console.warn("[Bankame] No se pudo guardar el log en localStorage:", e.message); } catch (_) {}
    }

    // DEBUG queda solo local para no inundar el backend con postMessages.
    if (nivel === "DEBUG") return;

    try {
      if (backendUrl) {
        fetch(backendUrl + "/api/bankame/log-event", {
          method:  "POST",
          headers: { "Content-Type": "application/json" },
          body:    JSON.stringify(entry),
          keepalive: true
        }).catch(function () {});
      }
    } catch (_) {}
  }
  window.bankameLog = bankameLog;
  window.bankameDumpLogs = function () {
    try { return JSON.parse(localStorage.getItem(BANKAME_LOG_KEY) || "[]"); }
    catch (e) { return []; }
  };

  // ═══════════════════════════════════════════════════════════════════
  // Inspección profunda de payloads
  // ═══════════════════════════════════════════════════════════════════
  var MAX_PROFUNDIDAD = 8;
  var MAX_CLAVES      = 400;

  function aplanar(valor, prefijo, salida, profundidad) {
    salida      = salida || {};
    prefijo     = prefijo || "";
    profundidad = profundidad || 0;

    if (Object.keys(salida).length >= MAX_CLAVES) return salida;

    if (valor === null || valor === undefined) {
      if (prefijo) salida[prefijo] = valor === null ? "(null)" : "(undefined)";
      return salida;
    }

    var tipo = typeof valor;
    if (tipo !== "object") {
      salida[prefijo || "(raíz)"] = tipo === "function" ? "(function)" : valor;
      return salida;
    }

    if (profundidad >= MAX_PROFUNDIDAD) { salida[prefijo] = "(demasiado profundo)"; return salida; }

    if (Array.isArray(valor)) {
      if (valor.length === 0) { salida[prefijo] = "(array vacío)"; return salida; }
      for (var i = 0; i < valor.length; i++) {
        aplanar(valor[i], prefijo + "[" + i + "]", salida, profundidad + 1);
      }
      return salida;
    }

    var claves;
    try { claves = Object.keys(valor); } catch (e) { salida[prefijo] = "(no enumerable)"; return salida; }
    if (claves.length === 0) { if (prefijo) salida[prefijo] = "(objeto vacío)"; return salida; }
    for (var j = 0; j < claves.length; j++) {
      var k = claves[j];
      aplanar(valor[k], prefijo ? prefijo + "." + k : k, salida, profundidad + 1);
    }
    return salida;
  }

  function normalizarClave(k) {
    return String(k).toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  function ultimoSegmento(ruta) {
    var partes = String(ruta).split(".");
    return partes[partes.length - 1].replace(/\[\d+\]/g, "");
  }

  function esValor(v) {
    if (v === null || v === undefined) return false;
    var s = String(v).trim();
    return s !== "" && s !== "(null)" && s !== "(undefined)" &&
           s !== "(objeto vacío)" && s !== "(array vacío)";
  }

  // Alias por campo, en dos niveles: primero los específicos, después los
  // genéricos (para no confundir "name" de un producto con el del cliente).
  var ALIAS_CLIENTE = {
    firstName: [
      ["shippingclientname", "firstname", "clientname", "customername", "nombrecliente", "givenname", "nombres"],
      ["nombre", "name"]
    ],
    lastName: [
      ["shippingclientlastname", "lastname", "clientlastname", "customerlastname", "apellidos", "familyname", "surname"],
      ["apellido"]
    ],
    email: [
      ["shippingemail", "clientemail", "customeremail", "correoelectronico", "email"],
      ["correo", "mail"]
    ],
    phone: [
      ["shipingphonenumber", "shippingphonenumber", "phonenumber", "clientphone", "customerphone", "numerocelular", "celular", "telefono"],
      ["phone", "tel", "movil"]
    ],
    street: [
      ["shippingaddress", "addressline1", "address1", "streetaddress", "direccion", "domicilio"],
      ["street", "calle", "address"]
    ],
    city: [
      ["shippingcity", "ciudad", "localidad"],
      ["city"]
    ],
    state: [
      ["shippingdepartment", "departamento", "department", "provincia", "province"],
      ["state", "region", "estado"]
    ],
    documento: [
      ["documentid", "numerodocumento", "carnet", "cedula", "ci", "dni", "nit"],
      ["documento", "document"]
    ]
  };

  // Rutas que NO son del cliente (productos, items del carrito, etc.)
  var RE_RUTA_IGNORADA = /(detail|product|item|line|cart|sku|variant)/i;

  function buscarEnMapa(mapa, tiers) {
    var rutas = Object.keys(mapa);
    for (var t = 0; t < tiers.length; t++) {
      var alias = tiers[t];
      for (var i = 0; i < rutas.length; i++) {
        var ruta = rutas[i];
        if (RE_RUTA_IGNORADA.test(ruta)) continue;
        if (!esValor(mapa[ruta])) continue;
        if (alias.indexOf(normalizarClave(ultimoSegmento(ruta))) !== -1) {
          return { ruta: ruta, valor: String(mapa[ruta]).trim() };
        }
      }
    }
    return null;
  }

  // Acumulador de datos de cliente vistos en CUALQUIER lado (postMessage,
  // callbacks espía, payloads previos). Sirve de red de contención.
  var clienteDetectado = {};

  function registrarCandidatos(origen, obj) {
    if (!obj || typeof obj !== "object") return;
    var mapa = aplanar(obj);
    var nuevos = {};
    Object.keys(ALIAS_CLIENTE).forEach(function (campo) {
      if (esValor(clienteDetectado[campo])) return;
      var hit = buscarEnMapa(mapa, ALIAS_CLIENTE[campo]);
      if (hit) {
        clienteDetectado[campo] = hit.valor;
        nuevos[campo] = hit.valor + "   ←   " + hit.ruta;
      }
    });
    if (Object.keys(nuevos).length) {
      bankameLog("INFO", "Datos de cliente detectados en " + origen, nuevos);
    }
  }

  var ultimoPayload = null;

  function inspeccionarPayload(etiqueta, payload) {
    ultimoPayload = payload;
    var mapa = aplanar(payload);
    bankameLog("INFO", "▼ " + etiqueta + " — payload completo (ruta → valor)", mapa);
    bankameLog("DEBUG", "▼ " + etiqueta + " — claves de primer nivel", {
      tipo:   Object.prototype.toString.call(payload),
      claves: (payload && typeof payload === "object") ? Object.keys(payload) : "(no es objeto)"
    });
    registrarCandidatos(etiqueta, payload);
    return mapa;
  }

  // ── Tipo de cambio ─────────────────────────────────────────────────
  var exchangeRate = parseFloat(config.exchangeRate);
  if (!exchangeRate || isNaN(exchangeRate) || exchangeRate <= 0) exchangeRate = 1;

  function aplicarTasa(monto) {
    return Math.round(parseFloat(monto || 0) * exchangeRate);
  }

  var widget   = null;
  var saleData = {
    saleId:               null,
    shopifyOrderId:       null,
    shopifyOrderNumber:   null,
    shopifyOrderName:     null,
    totalAmount:          null,
    initialPaymentAmount: null,
    ordenPromesa:         null
  };

  window.bankameDebug = {
    config:           config,
    saleData:         saleData,
    clienteDetectado: clienteDetectado,
    ultimoPayload:    function () { return ultimoPayload; },
    logs:             function () { return window.bankameDumpLogs(); }
  };

  // ── Helpers ────────────────────────────────────────────────────────
  function leerJSON(el, attr, fallback) {
    try {
      return JSON.parse(el.getAttribute(attr)) || fallback;
    } catch (e) {
      bankameLog("ERROR", "No se pudo leer " + attr + ": " + e.message);
      return fallback;
    }
  }

  function initWithRetry(initFn, maxRetries) {
    var retries = 0;
    maxRetries  = maxRetries || 50;
    (function attempt() {
      if (window.BankameWidget) {
        bankameLog("DEBUG", "SDK BankameWidget disponible", {
          intentos: retries,
          claves:   Object.keys(window.BankameWidget || {})
        });
        initFn();
      } else if (retries < maxRetries) {
        retries++;
        requestAnimationFrame(attempt);
      } else {
        bankameLog("WARN", "El SDK no cargó después de varios intentos.");
      }
    })();
  }

  var cacheProductos = {};
  function obtenerProductoJS(handle) {
    if (!handle) return Promise.resolve(null);
    if (cacheProductos[handle]) return cacheProductos[handle];
    cacheProductos[handle] = fetch("/products/" + handle + ".js")
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cacheProductos[handle];
  }

  // ═══════════════════════════════════════════════════════════════════
  // Selectores del tema t4s (The4)
  // ═══════════════════════════════════════════════════════════════════
  var formId = null;

  function obtenerFormulario() {
    if (formId) {
      var f = document.getElementById(formId);
      if (f) return f;
    }
    return document.querySelector('form[action*="/cart/add"]:not([id*="installment"])');
  }

  function obtenerVariantIdSeleccionada() {
    var form = obtenerFormulario();
    var el   = form ? form.querySelector('[name="id"]') : null;
    if (!el) {
      el = document.querySelector('.t4s-product__info-container [name="id"]')
        || document.querySelector('form[action*="/cart/add"] [name="id"]')
        || document.querySelector('[name="id"]');
    }
    return el ? el.value : null;
  }

  function obtenerInputCantidad() {
    var form = obtenerFormulario();
    var el   = form ? form.querySelector('input[name="quantity"]') : null;
    return el
      || document.querySelector('.t4s-product__info-container input[data-quantity-value]')
      || document.querySelector('.t4s-product__info-container input[name="quantity"]')
      || null;
  }

  // ═══════════════════════════════════════════════════════════════════
  // Datos frescos: producto individual
  // ═══════════════════════════════════════════════════════════════════
  function obtenerDatosProductoActual(handle) {
    var variantId = obtenerVariantIdSeleccionada();
    if (!variantId) return Promise.reject(new Error("No hay variante seleccionada"));

    var qtyInput = obtenerInputCantidad();
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    return obtenerProductoJS(handle).then(function (fullProductData) {
      if (!fullProductData) throw new Error("Error al obtener datos del producto");

      var currentVariant = fullProductData.variants.filter(function (v) {
        return String(v.id) === String(variantId);
      })[0];
      if (!currentVariant) throw new Error("Variante no encontrada");
      if (!currentVariant.available) {
        throw new Error("Este producto está agotado y no está disponible para compra con Bankame");
      }

      var compareAt = currentVariant.compare_at_price || null;
      var actual    = currentVariant.price;
      var precioFinal;
      if (compareAt && compareAt > actual) {
        precioFinal = compareAt;
        bankameLog("INFO", "Usando precio TACHADO", { precio: compareAt / 100 });
      } else {
        precioFinal = actual;
        bankameLog("INFO", "Usando precio normal", { precio: actual / 100 });
      }

      var gramos = parseInt(currentVariant.weight, 10) || 0;

      var producto = {
        variant_id:    String(variantId),
        product_id:    String(fullProductData.id),
        product_title: fullProductData.title,
        variant_title: currentVariant.title || "Default",
        quantity:      quantity,
        price:         (parseFloat(precioFinal) / 100).toFixed(2),
        sale_price:    (parseFloat(actual) / 100).toFixed(2),
        line_price:    (parseFloat(precioFinal) / 100 * quantity).toFixed(2),
        sku:           currentVariant.sku || "",
        handle:        handle,
        peso_gramos:   gramos,
        peso_total:    gramos * quantity
      };

      bankameLog("INFO", "Datos del producto obtenidos", producto);
      return [producto];
    });
  }

  // ═══════════════════════════════════════════════════════════════════
  // Datos frescos: carrito completo
  // ═══════════════════════════════════════════════════════════════════
  function obtenerDatosDelCarrito() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("Error al obtener el carrito");
        return r.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        if (items.length === 0) throw new Error("El carrito está vacío");

        return Promise.all(items.map(function (item) {
          return obtenerProductoJS(item.handle).then(function (pj) {
            var variante = null;
            if (pj) {
              variante = pj.variants.filter(function (v) {
                return String(v.id) === String(item.variant_id);
              })[0];
            }
            var compareAt = (variante && variante.compare_at_price) || item.compare_at_price || null;
            var actual    = item.final_price != null ? item.final_price : item.price;
            var precioFinal = (compareAt && compareAt > actual) ? compareAt : actual;
            var gramos = parseInt(item.grams, 10) || 0;

            return {
              variant_id:    String(item.variant_id),
              product_id:    String(item.product_id),
              product_title: item.product_title,
              variant_title: item.variant_title || "Default",
              quantity:      item.quantity,
              price:         (parseFloat(precioFinal) / 100).toFixed(2),
              sale_price:    (parseFloat(actual) / 100).toFixed(2),
              line_price:    (parseFloat(precioFinal) / 100 * item.quantity).toFixed(2),
              sku:           item.sku || "",
              handle:        item.handle,
              peso_gramos:   gramos,
              peso_total:    gramos * item.quantity
            };
          });
        }));
      });
  }

  function detallesDesdeItems(items) {
    return items.map(function (p) {
      var nombre = p.product_title;
      if (p.variant_title && p.variant_title !== "Default" && p.variant_title !== "Default Title") {
        nombre += " - " + p.variant_title;
      }
      return {
        product:       nombre,
        unitPrice:     aplicarTasa(p.price),
        discountPrice: aplicarTasa(p.sale_price),
        quantity:      p.quantity
      };
    });
  }

  function itemParaOrden(p) {
    return {
      variant_id:    p.variant_id,
      product_id:    p.product_id,
      product_title: p.product_title,
      variant_title: p.variant_title,
      quantity:      p.quantity,
      price:         p.price,
      line_price:    p.line_price,
      sku:           p.sku,
      handle:        p.handle,
      peso_gramos:   p.peso_gramos,
      peso_total:    p.peso_total
    };
  }

  function calcularTotales(productos, costoEnvio) {
    var subtotal = productos.reduce(function (sum, p) {
      return sum + parseFloat(p.line_price);
    }, 0);
    var envio = parseFloat(costoEnvio) || 0;
    var total = subtotal + envio;
    return {
      subtotal:     subtotal.toFixed(2),
      costoEnvio:   envio.toFixed(2),
      total:        total.toFixed(2),
      cuotaInicial: (total / 2).toFixed(2)
    };
  }

  // ═══════════════════════════════════════════════════════════════════
  // Resolución de los datos del cliente (INSTRUMENTADA)
  // ═══════════════════════════════════════════════════════════════════
  var LIQUID_MAP = {
    firstName: "first_name",
    lastName:  "last_name",
    email:     "email",
    phone:     "phone",
    street:    "address1",
    city:      "city",
    state:     "province"
  };

  function obtenerDatosCliente(payload, container) {
    var liquidCustomer = leerJSON(container, "data-customer", {}) || {};
    var p              = payload || {};
    var wc             = p.customer || p.client || p.cliente || {};
    var wcAddress      = (wc.address && typeof wc.address === "object" ? wc.address : null) || wc.shippingAddress || {};
    var sd             = p.shippingData || p.shipping_data || {};
    var mapaPayload    = aplanar(p);

    bankameLog("INFO", "Fuentes disponibles para el cliente", {
      payload_tiene_customer:     !!(p.customer || p.client || p.cliente),
      payload_tiene_shippingData: !!(p.shippingData || p.shipping_data),
      claves_payload:          Object.keys(p),
      claves_customer_payload: Object.keys(wc),
      claves_shippingData:     Object.keys(sd),
      claves_address_payload:  Object.keys(wcAddress),
      customer_shopify:        liquidCustomer,
      detectado_por_sniffer:   clienteDetectado
    });

    // Claves conocidas. El MISMO widget de Bankame, en la integración de
    // WooCommerce, manda el cliente así:
    //   payload.client       { firstname, lastname, email, phone_number,
    //                          address (string), city, department }
    //   payload.shippingData { shippingClientName, shippingClientLastName,
    //                          shippingEmail, shipingPhoneNumber (typo real),
    //                          shippingAddress, shippingCity, shippingDepartment }
    // v1.0.0 buscaba shippingClientName en la RAÍZ del payload y
    // firstName/first_name dentro de customer — con el shape de arriba nada
    // matchea, todos los campos caen al default y la orden queda como
    // "Cliente Bankame". Acá se cubren ambos shapes:
    var explicitos = {
      firstName: sd.shippingClientName     || p.shippingClientName     || wc.firstName || wc.first_name || wc.firstname || wc.name,
      lastName:  sd.shippingClientLastName || p.shippingClientLastName || wc.lastName  || wc.last_name  || wc.lastname,
      email:     sd.shippingEmail          || p.shippingEmail          || wc.email,
      phone:     sd.shipingPhoneNumber     || sd.shippingPhoneNumber   || p.shipingPhoneNumber || p.shippingPhoneNumber || wc.phone_number || wc.phone,
      street:    sd.shippingAddress        || p.shippingAddress        || wcAddress.street || wcAddress.address1 || (typeof wc.address === "string" ? wc.address : null),
      city:      sd.shippingCity           || p.shippingCity           || wcAddress.city   || wc.city,
      state:     sd.shippingDepartment     || p.shippingDepartment     || wcAddress.state  || wcAddress.province || wc.department,
      documento: sd.shippingDocument       || p.shippingDocument       || wc.document || wc.ci
    };

    var resumen   = {};
    var faltantes = [];
    var resuelto  = {};

    Object.keys(ALIAS_CLIENTE).forEach(function (campo) {
      var valor, origen;

      if (esValor(explicitos[campo])) {
        valor  = String(explicitos[campo]).trim();
        origen = "payload (clave conocida)";
      } else {
        var hit = buscarEnMapa(mapaPayload, ALIAS_CLIENTE[campo]);
        if (hit) {
          valor  = hit.valor;
          origen = "payload → " + hit.ruta;
        } else if (esValor(clienteDetectado[campo])) {
          valor  = clienteDetectado[campo];
          origen = "sniffer (postMessage / callback espía)";
        } else if (LIQUID_MAP[campo] && esValor(liquidCustomer[LIQUID_MAP[campo]])) {
          valor  = String(liquidCustomer[LIQUID_MAP[campo]]).trim();
          origen = "customer logueado en Shopify";
        } else {
          valor  = "";
          origen = "NO ENCONTRADO";
          faltantes.push(campo);
        }
      }

      resuelto[campo] = valor;
      resumen[campo]  = (valor || "(vacío)") + "   ←   " + origen;
    });

    bankameLog(faltantes.length ? "WARN" : "INFO",
      faltantes.length
        ? "Cliente resuelto CON CAMPOS FALTANTES — por eso la orden queda con datos genéricos"
        : "Cliente resuelto correctamente",
      { resumen: resumen, faltantes: faltantes }
    );

    var cliente = {
      email:      resuelto.email || "",
      first_name: resuelto.firstName || "Cliente",
      last_name:  resuelto.lastName  || "Bankame",
      phone:      resuelto.phone || "",
      address: {
        street:  resuelto.street || "",
        city:    resuelto.city   || "",
        state:   resuelto.state  || "",
        country: "BO"
      }
    };

    if (!esValor(resuelto.firstName) || !esValor(resuelto.email)) {
      bankameLog("ERROR",
        "El widget NO entregó nombre y/o email del cliente. Se usan los valores por defecto " +
        "('Cliente Bankame' / email vacío). Revisá el log '▼ SDK onClientConfirmed — payload completo' " +
        "para ver qué mandó realmente el widget.",
        { firstName: resuelto.firstName, email: resuelto.email }
      );
    }

    return cliente;
  }

  // ═══════════════════════════════════════════════════════════════════
  // 1) Crear orden PENDIENTE en Shopify + vincularla a la venta Bankame
  // ═══════════════════════════════════════════════════════════════════
  function crearOrdenPendienteYVincular(payload, container, obtenerItems) {
    bankameLog("INFO", "Creando orden pendiente en Shopify");

    return obtenerItems()
      .then(function (productos) {
        if (!productos || productos.length === 0) {
          throw new Error("No hay productos para crear la orden");
        }

        var shippingMethod = (payload && (payload.shippingMethod || payload.shipping_method))
                          || "Por coordinar (Bankame Widget)";
        var shippingCost   = (payload && (payload.shippingCost || payload.shipping_cost)) || 0;

        var totales = calcularTotales(productos, shippingCost);
        saleData.totalAmount          = totales.total;
        saleData.initialPaymentAmount = totales.cuotaInicial;

        bankameLog("INFO", "Totales calculados", totales);

        var cliente = obtenerDatosCliente(payload, container);

        var orderData = {
          customer:               cliente,
          shipping_address:       cliente.address,
          store_id:               storeId,
          shipping_method:        shippingMethod,
          shipping_cost:          totales.costoEnvio,
          items:                  productos.map(itemParaOrden),
          total_amount:           totales.total,
          initial_payment_amount: totales.cuotaInicial
        };

        // ► BODY EXACTO que recibe el backend. Si acá el cliente está bien
        //   y la orden en Shopify igual sale con datos genéricos, el problema
        //   está del lado del backend (create-pending-order), no del widget.
        bankameLog("INFO", "create-pending-order → BODY EXACTO enviado", orderData);

        return fetch(backendUrl + "/api/bankame/create-pending-order", {
          method:  "POST",
          headers: {
            "Content-Type":            "application/json",
            "X-Store-Id":              storeId,
            "ngrok-skip-browser-warning": "true"
          },
          body: JSON.stringify(orderData)
        });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            bankameLog("ERROR", "create-pending-order falló", {
              status: response.status,
              body:   errorData
            });
            throw new Error(errorData.error || ("Error " + response.status));
          });
        }
        return response.json();
      })
      .then(function (result) {
        bankameLog("INFO", "create-pending-order → RESPUESTA COMPLETA del backend", result);
        bankameLog("INFO", "create-pending-order OK — Shopify order creada", {
          shopify_order_id:     result.shopify_order_id,
          shopify_order_number: result.shopify_order_number,
          shopify_order_name:   result.shopify_order_name
        });

        saleData.shopifyOrderId     = result.shopify_order_id;
        saleData.shopifyOrderNumber = result.shopify_order_number;
        saleData.shopifyOrderName   = result.shopify_order_name;

        if (result.order_status_url || result.order_url) {
          window._bankameOrderUrl = result.order_status_url || result.order_url;
        }

        return vincularOrdenConBankame(result.shopify_order_id, saleData.saleId);
      });
  }

  function vincularOrdenConBankame(shopifyOrderId, bankameSaleId) {
    bankameLog("INFO", "link-order → enviando", {
      shopify_order_id: shopifyOrderId,
      bankame_sale_id:  bankameSaleId,
      store_id:         storeId
    });

    if (!shopifyOrderId || !bankameSaleId) {
      bankameLog("ERROR", "link-order abortado: shopify_order_id o bankame_sale_id vacío", {
        shopifyOrderId: shopifyOrderId,
        bankameSaleId:  bankameSaleId
      });
      return Promise.resolve();
    }

    return fetch(backendUrl + "/api/bankame/link-order", {
      method:  "POST",
      headers: {
        "Content-Type":            "application/json",
        "X-Store-Id":              storeId,
        "ngrok-skip-browser-warning": "true"
      },
      body: JSON.stringify({
        shopify_order_id: shopifyOrderId,
        bankame_sale_id:  bankameSaleId,
        store_id:         storeId
      })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (j) {
          if (!response.ok || j.success === false) {
            bankameLog("ERROR", "link-order respondió error", { status: response.status, body: j });
          } else {
            bankameLog("INFO", "link-order OK", j);
          }
        });
      })
      .catch(function (error) {
        bankameLog("ERROR", "link-order excepción: " + error.message);
      });
  }

  // ═══════════════════════════════════════════════════════════════════
  // 2) Marcar la orden como PAGADA
  // ═══════════════════════════════════════════════════════════════════
  function notificarPagoConfirmado(bankameTransactionId) {
    var requestBody = {
      bankame_transaction_id: bankameTransactionId,
      store_id:               storeId,
      shopify_order_id:       saleData.shopifyOrderId,
      total_amount:           saleData.totalAmount,
      initial_payment_amount: saleData.initialPaymentAmount,
      payment_date:           new Date().toISOString(),
      payment_method:         "QR",
      payment_reference:      "QR-" + Date.now()
    };

    bankameLog("INFO", "payment-confirmed → BODY EXACTO enviado", requestBody);

    return fetch(backendUrl + "/api/bankame/payment-confirmed", {
      method:  "POST",
      headers: {
        "Content-Type":            "application/json",
        "X-Store-Id":              storeId,
        "ngrok-skip-browser-warning": "true"
      },
      body: JSON.stringify(requestBody)
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || data.success === false) {
            bankameLog("WARN", "payment-confirmed respondió error (el webhook debería resolver)", {
              status: response.status,
              body:   data
            });
            return data;
          }
          bankameLog("INFO", "payment-confirmed OK", data);
          return data;
        });
      })
      .catch(function (error) {
        bankameLog("WARN", "payment-confirmed excepción (el webhook debería resolver): " + error.message);
      });
  }

  function vaciarCarrito() {
    return fetch("/cart/clear.js", {
      method:  "POST",
      headers: { "Content-Type": "application/json" }
    })
      .then(function () { bankameLog("INFO", "Carrito de Shopify vaciado"); })
      .catch(function (e) { bankameLog("WARN", "No se pudo vaciar el carrito: " + e.message); });
  }

  // ═══════════════════════════════════════════════════════════════════
  // Callbacks "espía": descubren qué otros eventos emite el SDK
  // ═══════════════════════════════════════════════════════════════════
  var CALLBACKS_ESPIA = [
    "onSaleCreated", "onSaleUpdated", "onSaleConfirmed",
    "onClientData", "onCustomerData", "onCustomerConfirmed",
    "onOrderConfirmed", "onShippingConfirmed", "onFormSubmit",
    "onStepChange", "onStateChange", "onStatusChange",
    "onQrGenerated", "onOpen", "onClose", "onCancel",
    "onEvent", "onMessage", "onUpdate", "onSuccess"
  ];

  function agregarEspias(cfg) {
    if (!ESPIAR_CALLBACKS) return cfg;
    CALLBACKS_ESPIA.forEach(function (nombre) {
      if (cfg[nombre]) return; // no pisar los reales
      cfg[nombre] = function (p) {
        inspeccionarPayload("SDK " + nombre + " (espía)", p);
      };
    });
    return cfg;
  }

  // ═══════════════════════════════════════════════════════════════════
  // Sniffer de postMessage del iframe del widget
  // ═══════════════════════════════════════════════════════════════════
  var mensajesLogueados = 0;
  var MAX_MENSAJES_LOG  = 150;

  function activarSniffer() {
    var origenWidget = null;
    try { origenWidget = widgetUrl ? new URL(widgetUrl).origin : null; } catch (_) {}

    bankameLog("DEBUG", "Sniffer de postMessage activo", {
      origen_esperado: origenWidget,
      verbose:         VERBOSE_POSTMESSAGE
    });

    window.addEventListener("message", function (ev) {
      try {
        var esDelWidget = origenWidget && ev.origin === origenWidget;
        if (!esDelWidget && !VERBOSE_POSTMESSAGE) return;
        if (mensajesLogueados >= MAX_MENSAJES_LOG) return;
        mensajesLogueados++;

        bankameLog("DEBUG", "postMessage " + (esDelWidget ? "DEL WIDGET" : "de " + ev.origin), {
          origin: ev.origin,
          data:   aplanar(ev.data)
        });

        if (esDelWidget) registrarCandidatos("postMessage del widget", ev.data);
      } catch (_) {}
    }, false);
  }

  // ═══════════════════════════════════════════════════════════════════
  // Creación del widget (común a producto y carrito)
  // ═══════════════════════════════════════════════════════════════════
  function crearWidget(container, details, obtenerItems) {
    bankameLog("INFO", "Details enviados al widget (init)", details);

    var cfg = {
      widgetUrl: widgetUrl,
      apiKey:    apiKey,
      details:   details,
      target:    "#" + container.id,

      onClientConfirmed: function (payload) {
        inspeccionarPayload("SDK onClientConfirmed", payload);

        var currentSaleId = (payload && (payload.saleId || payload.id)) || null;

        if (currentSaleId && window._bankameOrderCreatedForSaleId === currentSaleId) {
          // OJO: si este payload duplicado SÍ trae los datos del cliente y el
          // primero no, ese es el bug — la orden se creó con el payload pobre.
          bankameLog("WARN", "onClientConfirmed DUPLICADO — se ignora (la orden ya se creó). " +
            "Si este payload trae datos de cliente que el primero no tenía, ese es el problema.", {
            saleId: currentSaleId,
            cliente_en_este_payload: (function () {
              var m = aplanar(payload), r = {};
              Object.keys(ALIAS_CLIENTE).forEach(function (c) {
                var h = buscarEnMapa(m, ALIAS_CLIENTE[c]);
                if (h) r[c] = h.valor + "   ←   " + h.ruta;
              });
              return r;
            })()
          });
          return;
        }

        window._bankameOrderCreatedForSaleId = currentSaleId;
        window._bankamePaymentConfirmedFor   = null;
        window._bankameOrderUrl              = null;
        if (redirectTimer) { clearTimeout(redirectTimer); redirectTimer = null; }
        pendingRedirectUrl = null;

        saleData.saleId               = currentSaleId;
        saleData.shopifyOrderId       = null;
        saleData.shopifyOrderNumber   = null;
        saleData.shopifyOrderName     = null;
        saleData.totalAmount          = null;
        saleData.initialPaymentAmount = null;
        saleData.ordenPromesa         = null;

        saleData.ordenPromesa = crearOrdenPendienteYVincular(payload, container, obtenerItems)
          .catch(function (error) {
            bankameLog("ERROR", "Error al crear la orden pendiente: " + error.message, {
              stack: error && error.stack
            });
            window._bankameOrderCreatedForSaleId = null;
            window._bankameOrderUrl = (config.shopUrl || "/") + "?bankame_sale=" + (saleData.saleId || "");
          });
      },

      onPaymentConfirmed: function (payload) {
        inspeccionarPayload("SDK onPaymentConfirmed", payload);

        var transactionId = (payload && payload.saleId) || saleData.saleId;

        if (transactionId && window._bankamePaymentConfirmedFor === transactionId) {
          bankameLog("INFO", "Pago ya confirmado para saleId — ignorando duplicado", { saleId: transactionId });
          return;
        }
        window._bankamePaymentConfirmedFor = transactionId;

        var marcarPagada = function () {
          if (!transactionId) {
            bankameLog("ERROR", "No hay saleId para confirmar el pago");
            return;
          }
          return notificarPagoConfirmado(transactionId).catch(function (error) {
            bankameLog("ERROR", "Error al actualizar Shopify como pagada: " + error.message);
          });
        };

        if (saleData.ordenPromesa) {
          saleData.ordenPromesa.then(marcarPagada, marcarPagada);
        } else {
          marcarPagada();
        }

        if (mode === "cart" && config.clearCartOnSuccess !== false) vaciarCarrito();

        if (pendingRedirectUrl) return;
        var url = (config.shopUrl || "/") + "?bankame_sale=" + (transactionId || "");
        if (window._bankameOrderUrl) url = window._bankameOrderUrl;
        esperarCierreYRedirigir(url);
      },

      onError: function (error) {
        bankameLog("ERROR", "SDK reportó error: " + (error && error.message), {
          error: clonarParaLog(error)
        });
      }
    };

    agregarEspias(cfg);

    bankameLog("DEBUG", "BankameWidget.init → config", {
      target:               cfg.target,
      widgetUrl:            cfg.widgetUrl,
      apiKey_prefijo:       String(apiKey).slice(0, 14) + "…",
      cantidad_details:     details.length,
      callbacks_registrados: Object.keys(cfg).filter(function (k) { return typeof cfg[k] === "function"; })
    });

    var instancia = window.BankameWidget.init(cfg);

    try {
      bankameLog("DEBUG", "Instancia del widget creada", {
        tipo:   Object.prototype.toString.call(instancia),
        claves: instancia && typeof instancia === "object" ? Object.keys(instancia) : "(no es objeto)"
      });
    } catch (_) {}

    return instancia;
  }

  function convertirDetalles(details) {
    if (exchangeRate === 1) return;
    details.forEach(function (item) {
      if (item.unitPrice     != null) item.unitPrice     = aplicarTasa(item.unitPrice);
      if (item.discountPrice != null) item.discountPrice = aplicarTasa(item.discountPrice);
    });
    bankameLog("INFO", "Precios convertidos con tipo de cambio", { tasa: exchangeRate });
  }

  function actualizarDetalles(details) {
    if (!widget) return;
    if (typeof widget.updateDetails === "function") {
      widget.updateDetails(JSON.parse(JSON.stringify(details)));
    } else {
      bankameLog("WARN", "El SDK no expone updateDetails — los datos frescos se envían al confirmar.");
    }
  }

  // ═══════════════════════════════════════════════════════════════════
  // Widget en la página de PRODUCTO
  // ═══════════════════════════════════════════════════════════════════
  function initProductWidget() {
    var container = document.getElementById("bankame-product-btn");
    if (!container) {
      bankameLog("WARN", "No existe #bankame-product-btn en el DOM — ¿se renderizó el snippet?");
      return;
    }

    var handle = container.getAttribute("data-handle") || "";
    formId     = container.getAttribute("data-form-id") || null;

    var details = leerJSON(container, "data-product", []);
    if (!details.length) {
      bankameLog("ERROR", "data-product vacío — no se monta el widget");
      return;
    }

    var preciosPorVariante = leerJSON(container, "data-variants", {}) || {};

    bankameLog("DEBUG", "Contenedor de producto leído", {
      handle:      handle,
      form_id:     formId,
      form_existe: !!document.getElementById(formId || ""),
      customer:    leerJSON(container, "data-customer", {})
    });

    if (exchangeRate !== 1) {
      convertirDetalles(details);
      Object.keys(preciosPorVariante).forEach(function (vid) {
        var v = preciosPorVariante[vid];
        if (v.unitPrice     != null) v.unitPrice     = aplicarTasa(v.unitPrice);
        if (v.discountPrice != null) v.discountPrice = aplicarTasa(v.discountPrice);
      });
    }

    widget = crearWidget(container, details, function () {
      return obtenerDatosProductoActual(handle);
    });

    var lastQty       = 1;
    var lastVariantId = obtenerVariantIdSeleccionada();
    setInterval(function () {
      if (!widget) return;
      var cambio = false;

      var qtyInput = obtenerInputCantidad();
      if (qtyInput) {
        var qty = parseInt(qtyInput.value, 10) || 1;
        if (qty !== lastQty) {
          lastQty = qty;
          details[0].quantity = qty;
          cambio = true;
          bankameLog("INFO", "Cantidad actualizada", { qty: qty });
        }
      }

      var variantId = obtenerVariantIdSeleccionada();
      if (variantId && variantId !== lastVariantId) {
        lastVariantId = variantId;
        var precioVar = preciosPorVariante[variantId];
        if (precioVar) {
          container.style.display = precioVar.available === false ? "none" : "";

          if (precioVar.unitPrice !== details[0].unitPrice ||
              precioVar.discountPrice !== details[0].discountPrice) {
            details[0].unitPrice     = precioVar.unitPrice;
            details[0].discountPrice = precioVar.discountPrice;
            cambio = true;
            bankameLog("INFO", "Precio actualizado por variante", {
              variantId:     variantId,
              unitPrice:     precioVar.unitPrice,
              discountPrice: precioVar.discountPrice
            });
          }
        }
      }

      if (cambio) actualizarDetalles(details);
    }, 300);
  }

  // ═══════════════════════════════════════════════════════════════════
  // Widget en la página del CARRITO
  // ═══════════════════════════════════════════════════════════════════
  function initCartWidget() {
    var container = document.getElementById("bankame-cart-btn");
    if (!container) {
      bankameLog("WARN", "No existe #bankame-cart-btn en el DOM — ¿se renderizó el snippet?");
      return;
    }

    var details = leerJSON(container, "data-product", []);
    if (!details.length) {
      bankameLog("WARN", "Carrito sin items — no se monta el widget");
      return;
    }
    convertirDetalles(details);

    bankameLog("DEBUG", "Contenedor de carrito leído", {
      items:    details.length,
      customer: leerJSON(container, "data-customer", {})
    });

    widget = crearWidget(container, details, obtenerDatosDelCarrito);

    var firmaAnterior = null;
    setInterval(function () {
      if (!widget) return;
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var firma = c.item_count + ":" + c.total_price;
          if (firmaAnterior === null) { firmaAnterior = firma; return; }
          if (firma === firmaAnterior) return;
          firmaAnterior = firma;

          if (c.item_count === 0) {
            container.style.display = "none";
            return;
          }
          container.style.display = "";

          return obtenerDatosDelCarrito().then(function (items) {
            var nuevos = detallesDesdeItems(items);
            details.length = 0;
            nuevos.forEach(function (d) { details.push(d); });
            bankameLog("INFO", "Carrito cambió — details actualizados", details);
            actualizarDetalles(details);
          });
        })
        .catch(function () {});
    }, 3000);
  }

  // ── Esperar cierre del popup para redirigir ────────────────────────
  var pendingRedirectUrl = null;
  var redirectTimer      = null;

  function esperarCierreYRedirigir(orderUrl) {
    if (redirectTimer) clearTimeout(redirectTimer);
    pendingRedirectUrl = orderUrl;
    redirectTimer = setTimeout(function () {
      var url = window._bankameOrderUrl || pendingRedirectUrl;
      pendingRedirectUrl = null;
      redirectTimer      = null;
      if (url) window.location.href = url;
    }, 4000);
  }

  window.addEventListener("beforeunload", function () {
    if (widget && typeof widget.destroy === "function") widget.destroy();
  });

  // ═══════════════════════════════════════════════════════════════════
  // Panel flotante de logs (?bankame_logs=1)
  // ═══════════════════════════════════════════════════════════════════
  function renderBankameLogsPanel() {
    var localOn = false;
    try {
      localOn = new URL(window.location.href).searchParams.get("bankame_logs") !== null;
    } catch (_) {}
    var shortcutOn = localStorage.getItem("bankame_show_logs") === "1";
    if (!localOn && !shortcutOn) return;
    if (document.getElementById("bankameLogsPanel")) return;

    var panel = document.createElement("div");
    panel.id = "bankameLogsPanel";
    panel.style.cssText = "position:fixed;bottom:12px;right:12px;width:560px;max-width:95vw;height:420px;max-height:75vh;background:#0d1117;color:#e6edf3;border:1px solid #30363d;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,.4);z-index:2147483647;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:12px;display:flex;flex-direction:column;overflow:hidden;";

    var header = document.createElement("div");
    header.style.cssText = "padding:8px 12px;background:#161b22;border-bottom:1px solid #30363d;display:flex;justify-content:space-between;align-items:center;font-weight:600;gap:8px;";
    header.innerHTML = "<span>📋 Bankame Logs — " + storeId + " / widget-" + mode + "</span>";

    var btns = document.createElement("div");
    btns.style.cssText = "display:flex;gap:6px;flex-wrap:wrap;";
    var mkBtn = function (t, on) {
      var b = document.createElement("button");
      b.textContent = t;
      b.style.cssText = "background:#21262d;color:#e6edf3;border:1px solid #30363d;padding:3px 8px;border-radius:4px;cursor:pointer;font-size:11px;";
      b.onclick = on;
      return b;
    };

    btns.appendChild(mkBtn("🔄", function () { renderList(); }));
    btns.appendChild(mkBtn("🌐 Backend", function () {
      fetch(backendUrl + "/api/bankame/logs?store_id=" + storeId + "&limit=100", {
        headers: { "ngrok-skip-browser-warning": "true" }
      })
        .then(function (r) { return r.json(); })
        .then(function (j) { renderList((j.logs || []).slice().reverse(), "backend"); })
        .catch(function (e) { alert("Error backend: " + e.message); });
    }));
    btns.appendChild(mkBtn("📄 Copiar", function () {
      var txt = JSON.stringify(window.bankameDumpLogs(), null, 2);
      var fallback = function () {
        var ta = document.createElement("textarea");
        ta.value = txt;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand("copy"); } catch (_) {}
        ta.remove();
        alert("Logs copiados al portapapeles");
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(txt).then(function () { alert("Logs copiados al portapapeles"); }, fallback);
      } else {
        fallback();
      }
    }));
    btns.appendChild(mkBtn("🗑", function () { localStorage.removeItem(BANKAME_LOG_KEY); renderList(); }));
    btns.appendChild(mkBtn("✕", function () { panel.remove(); localStorage.removeItem("bankame_show_logs"); }));
    header.appendChild(btns);
    panel.appendChild(header);

    var list = document.createElement("div");
    list.style.cssText = "flex:1;overflow-y:auto;padding:8px 12px;";
    panel.appendChild(list);
    document.body.appendChild(panel);

    function renderList(externalLogs, source) {
      var logs = externalLogs || window.bankameDumpLogs().slice().reverse();
      if (logs.length === 0) {
        list.innerHTML = '<em style="color:#8b949e;">Sin logs ' + (source ? "(" + source + ")" : "(local)") + "</em>";
        return;
      }
      list.innerHTML = "";
      logs.forEach(function (e) {
        var row    = document.createElement("div");
        var colors = { ERROR: "#f85149", WARN: "#d29922", WARNING: "#d29922", INFO: "#58a6ff", DEBUG: "#8b949e" };
        var c      = colors[e.level] || "#e6edf3";
        row.style.cssText = "padding:5px 0;border-bottom:1px solid #21262d;";
        var ctxTxt = "";
        if (e.context !== null && e.context !== undefined) {
          try { ctxTxt = JSON.stringify(e.context, null, 2); }
          catch (_) { ctxTxt = "(no se pudo mostrar el contexto)"; }
        }
        var ctx = ctxTxt
          ? '<div style="color:#8b949e;font-size:11px;margin-top:2px;white-space:pre-wrap;word-break:break-word;">' + ctxTxt.replace(/</g, "&lt;") + "</div>"
          : "";
        row.innerHTML = '<div><span style="color:#8b949e;">' + (e.timestamp || "") + '</span> <b style="color:' + c + ';">[' + (e.level || "INFO") + "]</b> " + String(e.message || "").replace(/</g, "&lt;") + "</div>" + ctx;
        list.appendChild(row);
      });
    }
    renderList();

    // Autorefresco para no tener que apretar 🔄 durante la compra
    setInterval(function () {
      if (document.getElementById("bankameLogsPanel")) renderList();
    }, 2000);
  }
  window.mostrarBankameLogs = function () {
    localStorage.setItem("bankame_show_logs", "1");
    renderBankameLogsPanel();
  };

  // ── Punto de entrada ───────────────────────────────────────────────
  function arrancar() {
    renderBankameLogsPanel();
    activarSniffer();

    if (!apiKey || apiKey.indexOf("REEMPLAZAR") !== -1 || !widgetUrl) {
      bankameLog("WARN", "API Key o Widget URL no configurados — el widget no se monta.");
      return;
    }
    if (!backendUrl || !storeId) {
      bankameLog("WARN", "backendUrl o storeId no configurados — las órdenes NO se crearán en Shopify.");
    }
    bankameLog("INFO", "Bankame widget iniciado (v1.1.0-debug)", {
      storeId:      storeId,
      mode:         mode,
      widgetUrl:    widgetUrl,
      backendUrl:   backendUrl,
      exchangeRate: exchangeRate
    });

    if (config.isProduct === "yes") initWithRetry(initProductWidget);
    if (config.isCart    === "yes") initWithRetry(initCartWidget);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arrancar);
  } else {
    arrancar();
  }
})();